import {https, httpsFile} from './http.js';

// export function create_packing_list(page, currentpage,sortby,sortdir, search,status, plant, tab) {
//     return httpsFile().get(`stock-transfer?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&plant=${plant}&tab=${tab}`);
// }

export function index(page, currentpage,sortby,sortdir, search,status, plant, tab,created_by,receiving_plant, issuing_plant,dateFrom,dateTo) {
    return httpsFile().get(`packing_list?page=${page}&currentpage=${currentpage}
    &sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&created_by=${created_by}
    &receiving_plant=${receiving_plant}&issuing_plant=${issuing_plant}&date_from=${dateFrom}&date_to=${dateTo}`);
}

export function getPackingListDraft(page, currentpage,sortby,sortdir, search,status, plant, tab,created_by) {
    return httpsFile().get(`getPackingListDraft?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&created_by=${created_by}`);
}

export function show(id,page,currentpage){
    return https().get(`packing_list/${id}?page=${page}&currentpage=${currentpage}`);
}

export function showPackingListDraft(id,page,currentpage){
    return https().get(`showPackingListDraft/${id}?page=${page}&currentpage=${currentpage}`);
}

export function incrementExportCounter(id,page,currentpage){
    return https().get(`incrementExportCounter?id=${id}`);
}

export function manualExport(id,status){
    return https().get(`manualExport?id=${id}&status=${status}`);
}
export function cancelRequest(id){
    return https().get(`cancelRequest?id=${id}`);
}

export function cancelDraftPLRequest(id){
    return https().get(`cancelDraftPLRequest?id=${id}`);
}

export function create_packing_list(data){
    return https().post(`create_packing_list`,data);
}
export function createPDF(data){
    return https().post(`createPDF`,data);
}

export function downloadPdf(pl_id,type){
    return https().get(`attachment-download?pl_id=${pl_id}&type=${type}`);
}

export function exportPL(data) {
    return https().post(`exportPL`,data);
}